// extracted by mini-css-extract-plugin
export default {"pl1":"Spinner_pl1__vKbnq","pl1g":"Spinner_pl1g__N1dkk","pl1rect":"Spinner_pl1rect__wpceE","pl1a":"Spinner_pl1a__O9JO3","pl1b":"Spinner_pl1b__483I8","pl1c":"Spinner_pl1c__KM992"};